import {
  createContext,
  type PropsWithChildren,
  useContext,
  useEffect,
  useSyncExternalStore,
} from "react"

// The page under a FullPageDialog stays mounted, so its single-key hotkeys (Escape) keep listening;
// tracking open dialogs lets them stand down while covered.
let openCount = 0
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const setOpenCount = (next: number) => {
  openCount = next
  listeners.forEach((listener) => listener())
}

const InsideFullPageDialogContext = createContext(false)

export function FullPageDialogLayer({ children }: PropsWithChildren) {
  useEffect(() => {
    setOpenCount(openCount + 1)
    return () => setOpenCount(openCount - 1)
  }, [])
  return (
    <InsideFullPageDialogContext.Provider value={true}>
      {children}
    </InsideFullPageDialogContext.Provider>
  )
}

/** True when a FullPageDialog is open and the caller is rendered behind it rather than inside it. */
export function useIsCoveredByFullPageDialog() {
  const isInside = useContext(InsideFullPageDialogContext)
  const anyOpen = useSyncExternalStore(subscribe, () => openCount > 0)
  return anyOpen && !isInside
}
